import * as React from 'react'
import { SetStateAction } from 'react'
import { HairStylist } from '../../types/hairStylist'

interface State {
  readonly name: string
  readonly areaId: string
  readonly areaName: string
  readonly freeWord: string
  readonly stylists: HairStylist[]
  readonly selectedStarValue: number
}

export const DefaultValue: string = '0'
export const DefaultLabel: string = ''

export interface ExplorePageState extends State {
  readonly setState: React.Dispatch<SetStateAction<State>>
}

export function useExploreState(stylists: HairStylist[]): ExplorePageState {
  const [state, setState] = React.useState<State>({
    name: '',
    areaId: DefaultValue,
    areaName: DefaultLabel,
    freeWord: '',
    stylists,
    selectedStarValue: 0,
  })

  return { ...state, setState }
}
